import { useStaticQuery, graphql } from 'gatsby'

const QuestionGetter = () => {
  const { preguntasQuery } = useStaticQuery(
    graphql`
      query data {
        preguntasQuery: allGoogleSpreadsheetAlternativas {
          nodes {
            pregunta
            alternativa
            respuestaCorrecta
          }
        }
      }
    `,
  )
  const allPreguntas = preguntasQuery.nodes
  const porPregunta = groupBy(allPreguntas, 'pregunta')
  const preguntas = []
  Object.keys(porPregunta).map(pregunta => {
    preguntas.push({
      pregunta,
      alternativas: porPregunta[pregunta],
      respuestaCorrecta: porPregunta[pregunta].find(
        item => item.respuestaCorrecta,
      ),
    })
  })
  return preguntas
}

const groupBy = (list, props) => {
  return list.reduce((a, b) => {
    ;(a[b[props]] = a[b[props]] || []).push(b)
    return a
  }, {})
}

export default QuestionGetter
